export var QueueModes;!function(e){e.LOCAL="LOCAL",e.CAST="CAST"}(QueueModes||(QueueModes={}));